// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headers[data-v-b2e54f26]{display:flex;flex-direction:row;justify-content:space-evenly;align-items:center;border-bottom:1px solid var(--border);height:30px;width:calc(100% - 75px)}.headers div[data-v-b2e54f26]{width:100%}", ""]);
// Exports
module.exports = exports;
